import * as React from 'react';

import css from './MenuDelimiter.pcss';

const MenuDelimiter: React.FunctionComponent = () => <hr className={css.line} />;

export default MenuDelimiter;
